import styled from "styled-components";
import { desktop, mobile, tablet } from "src/components";

// TEXT SIZE ADJUSTMENT
// Main wrapper for the slider section
export const SliderWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    top: 1990px;
    left: 376px;
    width: 100%;
    max-width: 454px;
    height: 53px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    border: 1px solid #D8DEEC;
    border-radius: 10px;
    opacity: 1;
`;
// Header showing small to large A labels
export const HeaderText = styled.div`
    display: flex;
    justify-content: space-between;
    width: 93%;
`;
// A label with dynamic font sizes
export const Label = styled.span`
    font-size: ${({ large, medium, small }) =>
        large ? "16px" : medium ? "13px" : small ? "11px" : "0.875rem"};
`;
// Slider track where the thumb moves
export const SliderTrack = styled.div`
    position: relative;
    width: 93%;
    margin: 7px;
    height: 2px;
    background: #D8DEEC;
`;
// Gray guide lines (`|`) across the slider
export const BrokerLine = styled.div`
    position: absolute;
    top: 50%;
    left: -2px;
    right: -2px;
    display: flex;
    justify-content: space-between;
    color: gray;
    user-select: none; 
    pointer-events: none;
    transform: translateY(-60%);
`;
// Draggable circular thumb
export const SliderThumb = styled.div`
    position: absolute;
    top: 50%;
    left: ${({ left }) => left}%;
    transform: translate(-50%, -50%);
    width: 18px;
    height: 18px;
    background-color: #D8DEEC;
    border: 2px solid white;
    border-radius: 50%;
    cursor: pointer;
    z-index: 5;
`;

// TEXT ALIGNEMENT
export const Wrapper = styled.div`
    margin: 7px 0 27px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 3px;
    max-width: 100%;
    
`;

export const AlignButton = styled.button`
    border: 1px solid #D8DEEC;
    border-radius: 7px;
    background-color: ${p => (p.active ? "#D8DEEC" : "#FFFFFF")};
    box-shadow: 0px 3px 6px #00000029;
    color: ${p => (p.active ? "#FFFFFF" : "#8291b2")};
    opacity: 1;
    cursor: pointer;
    user-select: none;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 67px;
    height: 37px;

    svg {
        width: 20px;
        height: 20px;
    }

    &:hover {
      background-color: #D8DEEC;
      color: #fff;
    }
`;

export const Gap = styled.div`
    width: 13px;
`;

// FONT STYLE
// Container for the font buttons
export const ButtonGroup = styled.div`
    width: 100%;
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    margin-bottom: 15px;
`;

// Each font button styling
export const FontButton = styled.button`
    width: 126px;
    height: 70px;
    border: 1px solid #D8DEEC;
    border-radius: 10px;
    cursor: pointer;
    background-color: ${({ active }) => (active ? "#D8DEEC" : "#FFFFFF")};
    color: ${({ active }) => (active ? "#FFFFFF" : "#D8DEEC")};
    font-family: ${({ font }) => font};
    font-weight: ${({ weight }) => weight || 400};
    box-shadow: 0px 3px 6px #00000029;
    opacity: 1;
    font-size: 30px;
    transition: background-color 0.2s ease, color 0.2s ease;

    &:hover {
        background-color: #D8DEEC;
        color: white;
    }

    ${mobile`
        width: 100px;
        height: 50px;
    `}

     ${tablet`
        width: 80px;
        height: 50px;
    `}

     ${desktop`
        width: 126px;
        height: 70px;
    `}

`;

